import { connect } from 'react-redux';
import OwnAllItemsError from './own-all-items-error.component';
import { IOwnAllItemsErrorStateProps } from './own-all-items-error.types';
import { State } from 'widgets/redeem/root/root.reducers';

const mapStateToProps = (state: State): IOwnAllItemsErrorStateProps => ({
    faqUrl: state.config.links.faq
});

export default connect(mapStateToProps)(OwnAllItemsError);
